import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import "modules/BackordersDashboard/components/BackordersExportModal/BackordersExportModal.scss";

type BackordersExportModalProps = {
  open: boolean;
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
  onClose: () => void;
};

export const BackordersExportModal = ({ open, isPending, isSuccess, isError, onClose }: BackordersExportModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal size="tiny" open={open} onClose={onClose} className="BackordersExportModal">
      <Modal.Header>
        <div className="BackordersExportModal__export-file-container">
          <div>
            <Icon className="file" />
            <span> {t("v8_export", "Export")} </span>
          </div>

          <div className="BackordersExportModal__export-modal-button-container">
            <Button basic icon onClick={onClose} className="BackordersExportModal__export-modal-close-button">
              <div className="BackordersExportModal__export-modal-close-button-container">
                <Icon className="xmark" size="big" />
              </div>
            </Button>
          </div>
        </div>
      </Modal.Header>
      <Modal.Actions>
        <div className="BackordersExportModal__export-modal-content-text">
          {isPending && `${t("v8_loading", "Loading")}...`}
          {isSuccess && t("v8_export_queued", "Export queued for download. You will receive a notification when ready.")}
          {isError && t("v8_something_went_wrong", "Something went wrong, please contact the administrator")}
        </div>
      </Modal.Actions>
    </Modal>
  );
};
